import React, { useState } from "react";
import { MdLocationOn } from "react-icons/md";
import "./events_gallery.css";

import EventNavigation from "../EventNavigation/EventNavigation";
import Footer from "../Footer/Footer";

import radissonBlu1 from "./radissonblu.jpg";
import radissonBlu2 from "./radissonblu (2).jpg";
import radissonBlu3 from "./radissonblu (3).jpg";
import radissonBlu4 from "./radissonblu (4).jpg";
import radissonBlu5 from "./radissonblu (5).jpg";
import radissonBlu6 from "./radissonblu (6).jpg";
import radissonBlu7 from "./radissonblu (7).jpg";
import radissonBlu8 from "./radissonblu (8).jpg";

import firstMeet1 from "./1stMeetNGreet.jpg";
import firstMeet2 from "./1stMeetNGreet1.jpg";
import firstMeet3 from "./1stMeetNGreet2.jpg";
import firstMeet4 from "./1stMeetNGreet3.jpg";
import firstMeet5 from "./1stMeetNGreet4.jpg";
import secondMeet1 from "./2ndMeetNGreet.jpg";
import secondMeet2 from "./2ndMeetNGreet1.jpg";
import secondMeet3 from "./2ndMeetNGreet2.jpg";
import secondMeet4 from "./2ndMeetNGreet3.jpg";
import secondMeet5 from "./2ndMeetNGreet4.jpg";
import secondMeet6 from "./2ndMeetNGreet5.jpg";
import secondMeet7 from "./2ndMeetNGreet6.jpg";
import thirdMeet1 from "./3rdMeetNGreet.jpg";
import thirdMeet2 from "./3rdMeetNGreet1.jpg";
import thirdMeet3 from "./3rdMeetNGreet2.jpg";
import thirdMeet4 from "./3rdMeetNGreet3.jpg";
import thirdMeet5 from "./3rdMeetNGreet4.jpg";
import thirdMeet6 from "./3rdMeetNGreet5.jpg";
import thirdMeet7 from "./3rdMeetNGreet6.jpg";

const firstMeetImages = [firstMeet1, firstMeet2, firstMeet3, firstMeet4, firstMeet5];
const secondMeetImages = [secondMeet1, secondMeet2, secondMeet3, secondMeet4, secondMeet5, secondMeet6, secondMeet7];
const thirdMeetImages = [thirdMeet1, thirdMeet2, thirdMeet3, thirdMeet4, thirdMeet5, thirdMeet6, thirdMeet7];

const pastEvents = [
  {
    id: "radisson-blu-open-house",
    title: "Radisson Blu Open House",
    date: "July 01 | 2024",
    sortDate: "2024-07-01",
    location: "PC Hotel, Karachi",
    description:
      "A significant leap forward in purpose-built real estate and luxury hospitality. This grand event highlighted J7's commitment to transforming Islamabad's skyline and bolstering the hospitality sector across Pakistan.Facilitated by the Proptech Club, the launch not only showcased the sophisticated elegance of Radisson BLU Hotel & Residences, Islamabad but also emphasized our dedication to revitalizing the hospitality industry. ",
    images: [radissonBlu1, radissonBlu2, radissonBlu3, radissonBlu4, radissonBlu5, radissonBlu6, radissonBlu7, radissonBlu8],
  },
  // {
  //   id: "site-nooriabad-phase-iii",
  //   title: "SITE Nooriabad Phase III",
  //   date: "May 24 | 2024",
  //   sortDate: "2026-05-24",
  //   location: "Nooriabad Phase III",
  //   description:
  //     "A field-led ecosystem session focused on industrial growth, real estate development, and infrastructure opportunities.",
  // },
  {
    id: "first-official-meet-greet",
    title: "1st Official Meet & Greet",
    date: "October 02 | 2024",
    sortDate: "2024-10-02",
    location: "Karachi Club Annexe",
    description:
      "The PropTech Club proudly hosted the 1st Official Meet & Greet of The PropTech Club on October 2nd, 2024, at Karachi Club Annexe! A big thank you to all the industry leaders, innovators, and stakeholders who attended and made this event a resounding success. This gathering marks a significant milestone as we aim to foster greater collaboration and technological innovation in the real estate ecosystem of Pakistan. The event provided an incredible opportunity for professionals to connect, share ideas, and drive the industry forward through PropTech.",
    images: firstMeetImages,
  },
  {
    id: "second-official-meet-greet",
    title: "2nd Official Meet & Greet",
    date: "April 24 | 2025",
    sortDate: "2025-04-24",
    location: "The Lounge, DHA Karachi",
    description:
      "The 2nd Official Meet & Greet of The PropTech Club, powered by LandTrack.pk, brought together visionary minds from real estate, tech, development, and finance, all committed to redefining how Pakistan builds, buys, and scales through innovation. Held at The Lounge, DHA Karachi, this invite-only gathering was a powerful reflection of what’s possible when consistent community building happens beyond the big stage. At PropTech Club, this is just the beginning, stay tuned for more conversations, collaborations, and action across the country.",
    images: secondMeetImages,
  },
  {
    id: "third-official-meet-greet",
    title: "3rd Official Meet & Greet",
    date: "April 11 | 2026",
    sortDate: "2026-04-11",
    location: "Tapestry Cafe, DHA Karachi",
    description:
      "Real estate doesn’t lack opportunity , it lacks alignment. Developers, capital, and operators often move in parallel, but rarely in sync. And that’s where inefficiencies begin. The 3rd Official Eid Meet & Greet by PropTech Club at Tapestry Café was designed to address exactly that. Bringing the right stakeholders into one environment, not for visibility, but for clarity. The event was a powerful reminder that when the right people come together, with the right intent, real estate can move faster, smarter, and more efficiently.",
    images: thirdMeetImages,
  },
];

const sortEventsNewestFirst = (events) =>
  [...events].sort((a, b) => new Date(b.sortDate).getTime() - new Date(a.sortDate).getTime());

const EventSection = ({ event, onImageClick }) => (
  <article className="events_gallery_event">
    <div className="events_gallery_event_details">
      <p className="events_gallery_event_meta">{event.date}</p>
      <h2 className="events_gallery_event_title">{event.title}</h2>
      <p className="events_gallery_event_location">
        <MdLocationOn aria-hidden="true" />
        <span>{event.location}</span>
      </p>
      <p className="events_gallery_event_desc">{event.description}</p>
      {/* <div className="events_gallery_event_tags">
        {event.details.map((detail) => (
          <span key={detail}>{detail}</span>
        ))}
      </div> */}
      {event.ctaUrl && (
        <a className="events_gallery_event_cta" href={event.ctaUrl} target="_blank" rel="noopener noreferrer">
          {event.ctaLabel}
        </a>
      )}
    </div>

    <div className="events_gallery_image_scroller" aria-label={`${event.title} photos`}>
      {event.images.map((image, index) => (
        <button
          className="events_gallery_image_btn"
          key={`${event.id}-${index}`}
          type="button"
          onClick={() => onImageClick({ src: image, alt: `${event.title} photo ${index + 1}` })}
          aria-label={`Open ${event.title} photo ${index + 1}`}
        >
          <img src={image} alt={`${event.title} ${index + 1}`} loading="lazy" />
        </button>
      ))}
    </div>
  </article>
);

const EventsGallery = () => {
  const [activeImage, setActiveImage] = useState(null);
  const visibleEvents = sortEventsNewestFirst(pastEvents);

  return (
    <>
      <EventNavigation />

      <section id="events_gallery_intro">
        <div id="events_gallery_intro_inner">
          <p id="events_gallery_intro_eyebrow">PropTech Club Gallery</p>
          <h1 id="events_gallery_intro_hdng">Where real estate leaders meet what comes next.</h1>
          <p id="events_gallery_intro_txt">
            Browse the key moments from the PropTech Club ecosystem.
          </p>
        </div>
      </section>

      <main id="club_gallery_section">
        <section className="events_gallery_list" aria-live="polite">
          {visibleEvents.map((event) => (
            <EventSection event={event} key={event.id} onImageClick={setActiveImage} />
          ))}
        </section>
      </main>

      {activeImage && (
        <div className="events_gallery_lightbox" role="dialog" aria-modal="true" aria-label="Enlarged event photo">
          <button className="events_gallery_lightbox_backdrop" type="button" onClick={() => setActiveImage(null)} aria-label="Close image" />
          <div className="events_gallery_lightbox_content">
            <button className="events_gallery_lightbox_close" type="button" onClick={() => setActiveImage(null)}>
              Close
            </button>
            <img src={activeImage.src} alt={activeImage.alt} />
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default EventsGallery;
